import React from "react";
import "./InfoDetails.css";
import { Link } from "react-router-dom";

const InfoInsights = () => {
  return (
    <div className="info-detail">
      <div className="info-hero insights">
        <h2>Módulo de informes</h2>
        <p>
          Permite cargar y gestionar informes PDF, con asignación a usuarios y
          alertas de vencimiento.
        </p>
      </div>

      <section className="info-section">
        <h3>Funciones principales</h3>
        <ul>
          <li>Cargar informes PDF.</li>
          <li>Asignar informes a usuarios.</li>
          <li>Configurar avisos de vencimiento.</li>
        </ul>
      </section>

      <section className="info-section alt">
        <h3>Beneficio</h3>
        <p>
          Evita pérdidas de información crítica y asegura cumplimiento de
          normativas, recibir recordatorios de vencimientos.
        </p>
      </section>

      <section className="info-flow">
        <h3>Flujo de gestión de informes</h3>
        <ol>
            <li>Un usuario autorizado <b>carga un informe en PDF</b> al sistema.</li>
            <li>Selecciona los <b>usuarios</b> que podrán visualizar el informe.</li>
            <li>Configura una <b>fecha de vencimiento</b> si corresponde.</li>
            <li>El sistema envía <b>alertas y recordatorios</b> antes de la fecha.</li>
            <li>Los usuarios asignados pueden acceder y descargar el informe.</li>
        </ol>
      </section>


      <div className="info-cta">
        <h4>¿Querés gestionar tus informes?</h4>
        <Link to="/health-safety" className="cta-button">
          Ver informes
        </Link>
      </div>
    </div>
  );
};

export default InfoInsights;
